import { useState, useCallback } from 'react';
import type { JoinResponse } from '@gonzovnc/protocol';
import { GonzoApi } from '../core/api.js';
import { JoinPage } from './JoinPage.js';
import { RoomPage } from './RoomPage.js';
import { GONZO_BASE, browserFetch } from './config.js';

interface Session {
  api: GonzoApi;
  join: JoinResponse;
}

export function App() {
  const [session, setSession] = useState<Session | null>(null);

  const onJoined = useCallback((api: GonzoApi, join: JoinResponse) => {
    setSession({ api, join });
  }, []);

  const onLeave = useCallback(() => {
    setSession(null);
  }, []);

  if (!session) {
    return <JoinPage makeApi={() => new GonzoApi(GONZO_BASE, browserFetch)} onJoined={onJoined} />;
  }
  return <RoomPage api={session.api} join={session.join} onLeave={onLeave} />;
}
